import {
  del,
  get,
  post,
  put,
  attachpatch,
  RedirectloginApi,
  exportFile,
} from "./api_helper"
import * as url from "./url_helper"

const post_UserTimeSheet = data => post(url.POST_TIMESHEET, data)
const post_teams_workreports = data => post(url.POST_WORKREPORT, data)
const get_ProjectList = () => get(url.GET_ALL_PROJECT_LIST)
const post_VerifiedScreenList = data => post(url.GET_SCREEN_VERIFIED_LIST, data)
const activitysummaryList = data => post(url.GET_ACTIVITY_SUMMARY_LIST, data)
const exclude_screen = data => post(url.POST_EXCLUDE_SCREEN, data)
const exclude_screen_logs = data => post(url.POST_EXCLUDE_SCREEN_LOGS, data)
const get_team_screen_logs = data => post(url.POST_GET_SCREEN_LOGS, data)
const getprojectsummaryreports = data=>post(url.GET_PROJECT_SUMMARY_REPORT_SCREENS, data)
const getprojectsummaryreportsView = data=>post(url.GET_PROJECT_SUMMARY_REPORT, data)
// track profile
const get_category_list = () => get(url.GET_ALL_CATEGORY)
const get_profile_list = params => {
  let urlWithParam = `${url.GET_PROFILE_DATA}?companyid=${params.companyid}&pagesize=${params.pageSize}&pagenumber=${params.pageNumber}&SortField=${params?.SortField}&Direction=${params?.Direction}`
  if (params.categoryid === 0 || params.categoryid) {
    urlWithParam = `${urlWithParam}&categoryid=${params.categoryid}`
  }
  if (params.subCategoryid === 0 || params.subCategoryid) {
    urlWithParam = `${urlWithParam}&subCategoryid=${params.subCategoryid}`
  }
  if (params.userid === 0 || params.userid) {
    urlWithParam = `${urlWithParam}&userid=${params.userid}`
  }
  return get(urlWithParam, params)
}
const upateProfile = data => post(url.POST_UPDATE_PROFILE, data)
const deleteProfile = id => put(`${url.POST_DELETE_PROFILE}?id=${id}`)
const updatereport = data => post(url.POST_UPDATE_WORK_REPORT, data)

// Export WFH report (POST)
const exportDetailedWorkFromHomeReport = (data, exportname) =>
  data.export == true
    ? exportFile(url.EXPORT_WFH, data, `${exportname}Report.xlsx`)
    : post(url.EXPORT_WFH, data);


// UserList
const get_user_list = params => post(url.POST_USER_DATA, params)

// ADD NEW USER
const add_new_user = params => post(url.POST_NEW_USER_DATA, params)
const update_new_user = params => put(url.PUT_UPDATE_NEW_USER, params)
const update_bulk_upload = params => attachpatch(url.POST_BULK_UPLOAD, params)

// USER DEVICES / PRIMARY COMPUTER
const get_user_devices = userid => get(`${url.GET_USER_DEVICES}/${userid}`)
const set_primary_device = data => put(url.PUT_SET_PRIMARY_DEVICE, data)

// VALIDATE ATTENDANCE SYNC (FlexiTrac vs ERP)
const validate_attendance_sync = data => post(url.POST_VALIDATE_ATTENDANCE_SYNC, data)

// PRIMARY DEVICE HISTORY (effective-dated, admin)
const get_user_primary_device_history = userid => get(`${url.GET_USER_PRIMARY_DEVICE_HISTORY}/${userid}`)
const add_user_primary_device = data => post(url.POST_ADD_USER_PRIMARY_DEVICE, data)
const update_user_primary_device = data => put(url.PUT_UPDATE_USER_PRIMARY_DEVICE, data)
const delete_user_primary_device = id => del(`${url.DELETE_USER_PRIMARY_DEVICE}/${id}`)

//UPDATE ATTENDANCE
const update_attendance_details = params => post(url.UPDATE_ATTENDANCE, params)

//UPDATE TIMESHEET
const update_timesheet_details = params => post(url.UPDATE_TIMESHEET, params)

//UPDATE NON REPORT PENALTY
const update_penalty_points = params => post(url.UPDATE_PENALTY, params)

// TEAMS
const post_UserTeams = data => post(url.POST_TEAMS, data)
const post_ApprovesTeams = data => post(url.POST_APPROVES_TEAMS, data)
const post_RejectsTeams = data => post(url.POST_REJECTS_TEAMS, data)
const get_EvaluationHours = data =>
  get(
    `${url.GET_EVALUATION_HOURS}?accountId=${data?.accountId}&date=${data?.date}`
  )
const post_ReportQuickSendToClient = data =>
  post(url.POST_REPORT_QUICK_SEND_TO_CLIENTS, data)
const update_bookmarks = data => post(url.UPDATE_BOOK_MARKS, data)

//SUBMIT REPORTS
const submit_reports_selected_teams = data => post(url.SEND_REPORT, data)

// Aceess Group setting
const get_accessgroup_list = () => get(url.GET_ALL_ACCESSGROUP_LIST)

const updateAccessGroup = data => post(url.POST_UPDATE_ACCESSGROUP, data)

// Create Team Dropdown API
const get_create_team_lookup = () => get(url.GET_CREATE_TEAMLOOKUP)
const get_create_teams = data => post(url.GET_CREATE_TEAMS, data)
const get_create_team = data => post(url.GET_CREATE_TEAM, data)
const get_project_team = data => post(url.GET_PROJECT_TEAM, data)

//approve team
const approve_team = data => post(url.POST_APPROVE_TEAM, data)
const reject_team = data => post(url.POST_REJECT_TEAM, data)
const end_team = data => post(url.POST_END_TEAM, data)
const update_teams = teams => post(url.POST_UPDATE_TEAMS, teams)
const noapproveupdate_teams = teams =>
  post(url.POST_UPDATE_TEAMS_NO_APPROVED, teams)
const company_details = id => get(`${url.COMPANY_DETAILS}?Id=${id}`)
const summary_details = data => post(url.SUMMARY_DETAILS, data)

//upload application
const uploadapplications = apps =>
  attachpatch(url.POST_UPLOAD_APPLICATION, apps)

// Get Agents
const get_agents = data => get(url.GET_AGENT)
// get project status
const get_project_status = () => get(url.GET_PROJECT_STATUS)

// get project status total hours
const get_project_status_total_hours = (id) => get(`${url.GET_PROJECT_STATUS_TOTAL_HOUR}?projectId=${id}`)

// Get Billing Types
const get_billing_types = data => get(url.GET_BILLING_TYPES)

//Get Category
const get_category = data => post(url.GET_CATEGORY, data)
const save_category = data => post(url.SAVE_GATEGORY, data)
const new_user = data => post(url.NEW_USER, data)
const new_sub_category = data => post(url.NEW_SUB_CATEGORY, data)
const category_user = data =>
  del(`${url.CATEGORY_USER_DELETE}?categoryUserId=${data?.categoryUserId}&categoryId=${data?.categoryId}`)
const get_category_user = data =>
  get(
    `${url.GET_CATEGORY_USER}?categoryId=${data?.categoryId}&subcategoryId=${data?.subcategoryId}`
  )
const users_based_on_projects = data =>
  get(`${url?.USERS_BY_PROJECT}?subCategoryId=${data}`)
const add_users_for_projects = data => post(url.ADD_USERS_FOR_PROJECTS, data)
const post_CreateCategoryUserLink = data =>
  post(url.POST_CREATE_CATEGORY_USER_LINK, data)

// category user work Report
const get_WorkProjectList = data => post(url.GET_ALL_WORK_PROJECT_LIST, data)
const get_ScrutinyNotes = data => post(url.GET_ALL_SCRUTINY_NOTE, data)
// get type for scruting list
const get_ScrutinyNotesType = () => get(url.GET_ALL_SCRUTINY_NOTE_TYPE)
const get_allnonworkinghours = data => post(url.GET_ALL_NON_WORKING_HOURS, data)
const post_allnonworkinghours = (data) => post(url.POST_ALL_NON_WORKING_HOURS, data)
const del_allnonworkinghours = id => del(`${url.DEL_ALL_NON_WORKING_HOURS}?id=${id}`)

// update scrutiny status 
const update_scrutinystatus = data => post(url.UPDATE_SCRUTINY_STATUS_URL, data)

const post_WorkProjectScreenList = data =>
  post(url.GET_ALL_WORK_PROJECT_SCREENS_LIST, data)
// const post_ClientViewScreenList = data => post(url.CLIENT_VIEW_SCREENS_LIST, data)
const post_ClientViewScreenList = data =>
  post(
    `${url.CLIENT_VIEW_SCREENS_LIST}?date=${data?.date}&categoryId=${data?.clientId}`
  )
// redirect url
const redirtect_api = data =>
  RedirectloginApi(`${url.REDIRECT_LOGIN_WITH_SCREEN}?encryptedUserId=${data}`)

//change password
const changePassword = data => post(url.CHANGEPWD, data)
// get hours report
const getHoursReports = (data, exportname) =>
  data.export == true
    ? exportFile(url.GET_HOURS_REPORTS, data, `${exportname}Report.xlsx`)
    : post(url.GET_HOURS_REPORTS, data)

// get report submitted time report (admin)
const getReportSubmittedTime = data =>
  data.export == true
    ? exportFile(
        url.GET_REPORT_SUBMITTED_TIME,
        data,
        "ReportSubmittedTimeReport.xlsx"
      )
    : post(url.GET_REPORT_SUBMITTED_TIME, data)

// get webhook  dropdown list
const webhookslist = () => get(url.GET_WEB_HOOKS_LIST)
// get webhook  dropdown list
const webhooks = () => get(url.GET_WEB_HOOKS)
// Insert webhook list
const webhooksInsert = data => post(url.POST_WEB_HOOKS_INSERT, data)
// update webhook list
const webhooksUpdate = data => post(url.POST_WEB_HOOKS_UPDATE, data)
// delete webhook list
const webhooksDelete = id => put(`${url.PUT_WEB_HOOKS_DELETE}/${id}`)
// detailed work from home api 
const getDetailedWorkFromHome = data => post(url.GET_DETAILED_WORK_FORM_HOME, data)
// summary work from home api 
const getSummaryWorkFromHome = data => post(url.GET_SUMMARY_WORK_FORM_HOME, data)
//TimeLogByDate
const getTimeLogByDate = data => post(url.GET_TIMELOGBY_DATE, data)
const flag_timelog_invalid = data => put(url.PUT_FLAG_TIMELOG_INVALID, data)
const getActivityLogByDate = data => post(url.GET_ACTIVITYLOG, data)
const postMoviIdHHoursTimeLog = data =>
  post(url.POST_MOVE_ID_HOURS_TIMELOG, data)
const postAddManualEntryTimeLog = data =>
  post(url.POST_ADD_MANUAL_ENTRY_TIMELOG, data)
const postAddChangeStatusTimelog = data =>
  post(url.POST_ADD_CHANGE_STATUS_TIMELOG, data)
const gettMoviIdHHoursFromId = data =>
  post(url.GET_MOVE_ID_HOURS_FROMID_SELECT, data)
const gettMoviIdHHoursToId = data =>
  get(url.GET_MOVE_ID_HOURS_TOID_SELECT, data)

// ERP CRM Clients (ERPNext "Customer" doctype)
const get_erp_clients = () => get(url.GET_ERP_CLIENTS)
const get_erp_client = name => get(`${url.GET_ERP_CLIENT}/${encodeURIComponent(name)}`)
const sync_all_erp_clients = () => post(url.GET_ERP_CLIENTS)
const sync_erp_client = name => post(`${url.GET_ERP_CLIENT}/${encodeURIComponent(name)}`)

// CRM Organizations (Frappe CRM "CRM Organization" doctype)
const get_crm_orgs = () => get(url.GET_CRM_ORGS)
const get_crm_org = name => get(`${url.GET_CRM_ORG}/${encodeURIComponent(name)}`)
const sync_all_crm_orgs = () => post(url.GET_CRM_ORGS)
const sync_crm_org = name => post(`${url.SYNC_CRM_ORG}/${encodeURIComponent(name)}`)

// Workspace Audit
const saveWorkspaceAudit = data => post(url.POST_WORKSPACE_AUDIT_SAVE, data)
const getWorkspaceAuditList = data => post(url.POST_WORKSPACE_AUDIT_LIST, data)
const getWorkspaceAuditDashboard = data => post(url.POST_WORKSPACE_AUDIT_DASHBOARD, data)
const getWorkspaceAuditDetail = data => post(url.POST_WORKSPACE_AUDIT_DETAIL, data)

export {
  post_UserTimeSheet,
  get_ProjectList,
  post_VerifiedScreenList,
  post_UserTeams,
  get_category_list,
  get_profile_list,
  upateProfile,
  get_accessgroup_list,
  updateAccessGroup,
  get_user_list,
  add_new_user,
  get_create_team_lookup,
  get_create_team,
  update_new_user,
  get_user_devices,
  set_primary_device,
  validate_attendance_sync,
  get_user_primary_device_history,
  add_user_primary_device,
  update_user_primary_device,
  delete_user_primary_device,
  get_create_teams,
  get_category,
  save_category,
  new_user,
  approve_team,
  reject_team,
  end_team,
  new_sub_category,
  post_ApprovesTeams,
  post_RejectsTeams,
  post_teams_workreports,
  updatereport,
  deleteProfile,
  update_teams,
  get_WorkProjectList,
  post_WorkProjectScreenList,
  update_bulk_upload,
  changePassword,
  category_user,
  company_details,
  summary_details,
  get_project_team,
  activitysummaryList,
  noapproveupdate_teams,
  exclude_screen,
  exclude_screen_logs,
  uploadapplications,
  post_ClientViewScreenList,
  get_team_screen_logs,
  redirtect_api,
  get_category_user,
  submit_reports_selected_teams,
  get_EvaluationHours,
  users_based_on_projects,
  add_users_for_projects,
  getTimeLogByDate,
  flag_timelog_invalid,
  getActivityLogByDate,
  get_agents,
  get_billing_types,
  postMoviIdHHoursTimeLog,
  postAddManualEntryTimeLog,
  postAddChangeStatusTimelog,
  gettMoviIdHHoursFromId,
  gettMoviIdHHoursToId,
  post_CreateCategoryUserLink,
  post_ReportQuickSendToClient,
  getHoursReports,
  getReportSubmittedTime,
  webhookslist,
  webhooks,
  webhooksInsert,
  webhooksUpdate,
  webhooksDelete,
  getprojectsummaryreports,
  getprojectsummaryreportsView,
  getDetailedWorkFromHome,
  getSummaryWorkFromHome,
  get_project_status,
  get_ScrutinyNotes,
  get_ScrutinyNotesType,
  get_project_status_total_hours,
  update_scrutinystatus,
  get_allnonworkinghours,
  post_allnonworkinghours,
  del_allnonworkinghours,
  update_attendance_details,
  update_timesheet_details,
  update_penalty_points,
  update_bookmarks,
  exportDetailedWorkFromHomeReport,
  saveWorkspaceAudit,
  getWorkspaceAuditList,
  getWorkspaceAuditDashboard,
  getWorkspaceAuditDetail,
  get_erp_clients,
  get_erp_client,
  sync_all_erp_clients,
  sync_erp_client,
  get_crm_orgs,
  get_crm_org,
  sync_all_crm_orgs,
  sync_crm_org,
}
